export default {
  init() {

    $('.emma-switch').on('click', function(){
      $('.switch-desc').empty();
      if( $('.emma-switch input').is(':checked') ){
        $('.switch-desc').append('Als Testmailing versenden');
        $('.test-recipient').show();
      }else{
        $('.switch-desc').append('Newsletter an alle Empfänger versenden');
        $('.test-recipient').hide();
      }
    });


    // JavaScript to be fired on the emma page, after the init JS
    $('.send-emma').on('submit', function(e) {
      $('.result').fadeOut();
      e.preventDefault();
      var $form = $(this);
      // var $eventlist = $('input:hidden[name=event_list]').val();
			$.ajax( {
				url: $form.attr('action'),
        data: new FormData(this),
        // eventlist: $eventlist,
        action: 'send_emma',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				type: 'POST', 
          beforeSend: function(){
            $form.slideUp();
            
          },
          success: function(data){ 
            $('.result').append('<div class="alert alert-success" role="alert">' + data + '</div>').fadeIn();
            setTimeout(function(){
              
            }, 3000)
          },
          
          error: function(data){
            $('.result').append('<div class="alert alert-warning" role="alert">' + data + '</div>').fadeIn();
				},  
			});
			
			
    });
  },
  finalize() {

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/emmaAll.js